<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400">
      <v-card>
        <v-card-title class="headline">
          更新情報確認
        </v-card-title>
        <v-card-text>
          <div>
            生年月日：西暦{{ birthday.year }}年{{ birthday.month }}月
            {{ birthday.day }}日生まれ
          </div>
          <div>
            性別：{{ birthday.sex }}
          </div>
          <div>
            氏名：{{ userInfo.shimei }}
          </div>
          <div>
            ふりがな：{{ userInfo.shimeiKana }}
          </div>
          <div>
            メールアドレス：{{ userInfo.mail }}
          </div>
          <!-- <div v-if="!isRegisteredUser">
            パスワード：{{ userInfo.password }}
          </div> -->
          <div>
            職業：{{ userInfo.selectedJobItem }}
          </div>
          <div>
            用途：{{ userInfo.selectedUsecase }}
          </div>
          <div>
            どのようにこのサイトを知ったか？：<br>
            {{ userInfo.learn }}
          </div>
          <div>
            案内メール：
            {{ userInfo.receiveMail == 'YES' ? '受信してもよい' : '受信しない' }}
          </div>
        </v-card-text>
        <!-- <v-card-text>
          <div style="text-align:left;">
            <v-btn
              href="https://www.sai-labo.co.jp/tofservice"
              target="_blank"
              text
              color="link"
              min-height="20"
              class="x-small post-link py-1 px-2">
              利用規約
            </v-btn>
            および
            <v-btn
              href="https://www.sai-labo.co.jp/privacy"
              target="_blank"
              text
              color="link"
              min-height="20"
              class="x-small post-link py-1 px-2">
              プライバシーポリシー
            </v-btn>
            をご確認下さい
          </div>
        </v-card-text> -->
        <v-card-actions>
          <v-spacer />
          <div class="text-align: center;">
            <v-btn
              color="green darken-1"
              text
              @click="dialog = false">
              修正
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="sendBirthDay()">
              更新
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import { functions } from '@/plugins/firebase'

export default {
  props: {
    isInputValid: {
      type: Boolean,
      default: false
    }
  }
  ,
  data () {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapState({
      birthday: 'user_birthday',
      userMeishiki: 'user_meishiki',
      userInfo: 'user_info',
    }),
    ...mapGetters(['isRegisteredUser']),
  },
  methods: {
    sendBirthDay: async function() {

      const func = functions.httpsCallable('registerUserInfo')
      const args = {
        birthday: this.birthday,
        shimei: this.userInfo.shimei,
        shimeiKana: this.userInfo.shimeiKana,
        mail: this.userInfo.mail,
        job: this.userInfo.selectedJobItem,
        usecase: this.userInfo.selectedUsecase,
        learn: this.userInfo.learn,
        receiveMail: this.userInfo.receiveMail
      }
      await func(args).then((res) => {
        this.registerUserMeishiki({
          userMeishiki: res.data.meishiki,
          birthday: this.birthday,
          userInfo: this.userInfo,
        })
      })
      this.dialog = false
      this.$router.push({ name: 'calendar' }, () => {})
    },
    open() {
      this.dialog = true
    },
    ...mapActions(['registerUserMeishiki', 'registerUserInfo']),
  },
}
</script>
